import React, { FC } from "react";

import { camelCase } from "lodash";
import { useTranslation } from "react-i18next";

import { DetailPanel, DetailPanels } from "@/components/organisms";

import { panelDescriptionSchema, panelEngineSchema, panelRegistrationDatesSchema } from "./panelSchema";

const AccordionIndex = {
    DESCRIPTION: "description",
    REGISTRATION: "description",
    ENGINE: "shipengine",
};

type ShipTabPanelProps = {
    details: MyBrokerApi.Ship;
};

const ShipTabPanel: FC<ShipTabPanelProps> = ({ details }) => {
    const { t, i18n } = useTranslation();

    return (
        <DetailPanels defaultDetailPanelOpen={AccordionIndex.DESCRIPTION}>
            <DetailPanel
                dataTestId="insured_good_detail_ship_description"
                id={AccordionIndex.DESCRIPTION}
                title={t("Common.Description")}
                infoList={panelDescriptionSchema(details, i18n.language)}
            />
            <DetailPanel
                dataTestId="insured_good_detail_ship_registration_dates"
                id={AccordionIndex.REGISTRATION}
                title={t("InsuredGood.Details.Ship.AdministrativeDates")}
                infoList={panelRegistrationDatesSchema(details)}
            />
            {details.shipEngines.map((shipEngine, index) => (
                <DetailPanel
                    dataTestId={`insured_good_detail_ship_engine_${index}`}
                    id={AccordionIndex.ENGINE}
                    key={`enginepanel-${camelCase(shipEngine.chassisEng)}`}
                    title={index === 0 && t("InsuredGood.Details.Ship.Engines")}
                    subtitle={`${t("InsuredGood.Details.Ship.Engine")} ${index}`}
                    infoList={panelEngineSchema(shipEngine, index, i18n.language)}
                />
            ))}
        </DetailPanels>
    );
};

export default ShipTabPanel;
